'use strict';

angular.module('licensure.services')
    .factory('VoucherPay', ['$http', '$q', function ($http, $q) {
        var saveLicenseVoucherCharge = function (licenseRequestID) {
            var d = $q.defer();

            $http.post(apiLocation + '/api/VoucherPay/LicenseVoucherCharge/' + licenseRequestID)
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    d.resolve(null);
                });

            return d.promise;
        }

        return {
            saveElement: function (answer, licenseRequestID, formCompleted) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/VoucherPay/SaveElement/' + licenseRequestID, answer, formCompleted)
                    .then(function (response) {
                        if (formCompleted) {
                            saveLicenseVoucherCharge(licenseRequestID).then(function () {
                                d.resolve();
                            })
                        }
                        else {
                            d.resolve(response.data);
                        }
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    })

                return d.promise;
            },

            getExistingVouchersByLicenseRequestID: function (licenseRequestID) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/VoucherPay/ExistingVouchers', {
                        params: {
                            licenseRequestID: licenseRequestID
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            }
        }
    }])
    ;